<template>
  <div class="page_wrapper container-fluid lecture_area">
    <div class="row page_header lecture_header">
      <lectures-header
        lecture-type="徵才說明會"
        :title-ch="'徵才說明會'"
        :title-en="'Recruitment Information Session'"
      />
    </div>
    <div class="row lecture_details_content">
      <lecture-details
        lecture-type="徵才說明會"
        lecture-type-en="recruitment"
      />
    </div>
  </div>
</template>
<script>
import LecturesHeader from '~components/pages/lectures/LecturesHeader'
import LectureDetails from '~components/pages/lectures/LectureContent'
export default {
  name: 'LectureRecruitmentContent',
  routerName: 'LecturesRecruitment:id',
  components: {
    LecturesHeader,
    LectureDetails
  }
}
</script>
